module.exports = __webpack_public_path__ + "img/VIANDE.1f69ab37.png";